export default __webpack_public_path__ + "static/media/back-arrow.e9b403b9.svg";